var _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 100",
    role: "img",
    "aria-label": "SoKo Water Systems wordmark",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SoKo Water Systems") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 62,
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: 56,
    fontWeight: 500,
    fill: "#0B3A4A",
    letterSpacing: 3,
    textAnchor: "middle"
  }, "SOKO")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 82,
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: 10,
    fontWeight: 400,
    fill: "#5F5E5A",
    letterSpacing: 3,
    textAnchor: "middle"
  }, "WATER SYSTEMS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWordmark);
export default __webpack_public_path__ + "static/media/logo_wordmark.def146365923b2ce8217d4a94576ce5c.svg";
export { ForwardRef as ReactComponent };